<template>
  <div class="wager-detail">
    <div class="wager-detail__header">
      <img
          @click="$parent.$emit('close')"
          class="wager-detail__header__close"
          src="@/assets/images/ticket/remove.png"
      />
    </div>
    <div class="wager-detail__content">
      <div class="wager-detail__content__items-main">
        <div class="wager-detail__content__items-main__item">
          <div class="wager-detail__content__items-main__title">
            TRANSACTION ID
          </div>
          <div class="wager-detail__content__items-main__value">
            {{ wagerDetailTransaction.betslipId }}
          </div>
        </div>
        <div class="wager-detail__content__items-main__item">
          <div class="wager-detail__content__items-main__title">
            DATE
          </div>
          <div class="wager-detail__content__items-main__value">
            {{ $filters.formatDate(wagerDetailTransaction.date) }}
          </div>
        </div>
        <div class="wager-detail__content__items-main__item">
          <div class="wager-detail__content__items-main__title">
            TOTAL BET AMOUNT
          </div>
          <div class="wager-detail__content__items-main__value">
            {{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(wagerDetailTransaction.totalPaid) }}
          </div>
        </div>
      </div>
      <div v-for="(detail, k) in wagerDetail"
           :key="k">
        <div
            v-for="(valueDetail, keyDetail) in detail"
            :key="keyDetail"
        >
          <div class="wager-detail__content__info">
            <div class="wager-detail__content__info__title">
              {{ valueDetail.name }}
            </div>
            <div class="wager-detail__content__info__draw-date">
              <strong>Draw Date:</strong> {{ $filters.formatDate(valueDetail.drawDate) }}
            </div>
            <div class="wager-detail__content__info__draw-id">
              <strong>Draw ID:</strong> {{ valueDetail.drawId }}
            </div>
            <div class="wager-detail__content__info__results">
              <label><strong>Results:</strong></label>
              <div class="wager-detail__content__info__results__numbers">
                <div
                    v-for="(item, index) in valueDetail.results && valueDetail.results[0]"
                    :key="index"
                    class="wager-detail__content__info__results-number">
                  <a>{{ item }}</a>
                </div>
                <div
                    v-for="(item, index) in valueDetail.results && valueDetail.results[1]"
                    :key="index"
                    class="wager-detail__content__info__results-number bonus-ball">
                  <a>{{ item }}</a>
                </div>
              </div>
            </div>
          </div>
          <div
              v-for="(item, index) in valueDetail.bets"
              :key="index"
              class="wager-detail__content__items-main wager-detail__content__items-main-detail"
          >
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                BET ID
              </div>
              <div class="wager-detail__content__items-main__value">
                {{ item.betId }}
              </div>
            </div>
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                YOUR BET
              </div>
              <div
                  v-if="item.numbers.length > 0"
                  class="wager-detail__content__items-main__value"
              >
                <b>{{ item.summary }}</b> <br> {{ item.text }}
                <div class="wager-detail__content__items-main__value__numbers">
                  <div
                      v-for="(item, index) in item.numbers[0]"
                      :key="index"
                      class="wager-detail__content__items-main__value__number">
                    <a>{{ item }}</a>
                  </div>
                  <div
                      v-for="(item, index) in item.numbers[1]"
                      :key="index"
                      class="wager-detail__content__items-main__value__number bonus-ball">
                    <a>{{ item }}</a>
                  </div>
                </div>
              </div>
              <div
                  v-if="item.numbers.length === 0"
                  class="wager-detail__content__items-main__value"
              >
                {{ item.summary }}: {{ item.text }}
              </div>
            </div>
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                WAGER TYPE
              </div>
              <div class="wager-detail__content__items-main__value">
                {{ item.betType }}
              </div>
            </div>
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                ODDS
              </div>
              <div class="wager-detail__content__items-main__value">
                {{ $filters.formatThousandNumber(item.odds) }}
              </div>
            </div>
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                BET AMOUNT
              </div>
              <div class="wager-detail__content__items-main__value">
                {{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.stake) }}
              </div>
            </div>
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                POTENTIAL RETURN
              </div>
              <div class="wager-detail__content__items-main__value">
                {{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.stake * item.odds) }}
              </div>
            </div>
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                WINNINGS TAX
              </div>
              <div class="wager-detail__content__items-main__value">
                {{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.tax) }}
              </div>
            </div>
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                TOTAL POTENTIAL RETURN
              </div>
              <div class="wager-detail__content__items-main__value">
                {{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber((item.stake * item.odds) - item.tax) }}
              </div>
            </div>
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                ACTUAL RETURN
              </div>
              <div class="wager-detail__content__items-main__value">
                {{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.winnings) }}
              </div>
            </div>
            <div class="wager-detail__content__items-main__item">
              <div class="wager-detail__content__items-main__title">
                STATUS
              </div>
              <div class="wager-detail__content__items-main__value">
                {{ item.status }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    wagerDetail: {
      type: Object
    },
    wagerDetailTransaction: {
      type: Object
    }
  },
  components: {
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/wager/wager-detail-mobile.scss"/>
